module.exports = __webpack_public_path__ + "static/media/tipologia3.52e46d9e.png";